import { SET_BUS_ISSUE } from "../actions/ticket";



export default function setBusTicket(state = [], action = {}) {
    switch (action.type) {
        case SET_BUS_ISSUE:
            const { BusIssue } = action;

            return {
                ...state,
                BusIssue,
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/BusIssueReducer.js